export const taxisUserData = {
    // abiGcrCode: "111111111111",
    companyName: "Digital IKE",
    legalVat: "123123128",
    // companyLegalType: "Ιδιωτική Κεφαλαιουχική Εταιρεία",
    abiDistrict: "Ιωάννινα",
    buildCity: "Ιωάννινα",
    buildStreet: "Μιχαήλ Αγγέλου 5",
    buildTk: "45332",
}

export const taxisUserData1 = {
    // abiGcrCode: "111111111111",
    companyName: "Digital IKE1",
    legalVat: "979701944",
    // companyLegalType: "Ιδιωτική Κεφαλαιουχική Εταιρεία",
    abiDistrict: "Αθήνα",
    buildCity: "Αθήνα",
    buildStreet: "Σόλωνος 85",
    buildTk: "10680",
    totalAmountSorefsis: 300001
}

export const taxisUserData2 = {
    // abiGcrCode: "111111111111",
    companyName: "Digital IKE2",
    legalVat: "979701944",
    // companyLegalType: "Ιδιωτική Κεφαλαιουχική Εταιρεία",
    abiDistrict: "Αθήνα",
    buildCity: "Αθήνα",
    buildStreet: "Σόλωνος 8",
    buildTk: "10680",
    totalAmountSorefsis: 100000
}

export const taxisUserDataUAT = {
    // abiGcrCode: "111111111111",
    companyName: "Digital IKE3",
    legalVat: "979701944",
    // companyLegalType: "Ιδιωτική Κεφαλαιουχική Εταιρεία",
    abiDistrict: "Αθήνα",
    buildCity: "Αθήνα",
    buildStreet: "Σόλωνος 8",
    buildTk: "10680",
    totalAmountSorefsis: 100000
}